module.exports = __webpack_public_path__ + "static/media/U2-T1-1-10d_R.bbca8c69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U2-T1-1-10d_R.svg
// module id = 588
// module chunks = 0